import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { useEffect } from "react";

// Scroll to top on route change
function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
}

// Public pages
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ComparePage from "./pages/ComparePage";
import QuotePage from "./pages/QuotePage";
import GuidancePage from "./pages/GuidancePage";
import UsedMachinesPage from "./pages/UsedMachinesPage";
import AirCompressorPage from "./pages/AirCompressorPage";
import AccessoriesPage from "./pages/AccessoriesPage";
import DryIcePelletizerPage from "./pages/DryIcePelletizerPage";
import ReturnPolicyPage from "./pages/ReturnPolicyPage";
import ShippingPolicyPage from "./pages/ShippingPolicyPage";
import TermsPage from "./pages/TermsPage";
import ThankYouPage from "./pages/ThankYouPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import RentPage from "./pages/RentPage";
import RentalDetailPage from "./pages/RentalDetailPage";
import RentalConfirmationPage from "./pages/RentalConfirmationPage";

// Blog
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";

// Customer Auth
import CustomerLoginPage from "./pages/CustomerLoginPage";
import CustomerRegisterPage from "./pages/CustomerRegisterPage";
import CustomerDashboardPage from "./pages/CustomerDashboardPage";

// Admin pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminQuotes from "./pages/admin/AdminQuotes";
import AdminComparisons from "./pages/admin/AdminComparisons";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminRentals from "./pages/admin/AdminRentals";
import AdminBlog from "./pages/admin/AdminBlog";

// Layouts
import PublicLayout from "./layouts/PublicLayout";
import AdminLayout from "./layouts/AdminLayout";
import { CartProvider } from "./lib/CartContext";
import { AuthProvider } from "./lib/AuthContext";

// Checkout pages
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";

function App() {
    return (
        <AuthProvider>
        <CartProvider>
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                {/* Public Routes */}
                <Route element={<PublicLayout />}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/products" element={<ProductsPage />} />
                    <Route path="/products/:productId" element={<ProductDetailPage />} />
                    <Route path="/compare" element={<ComparePage />} />
                    <Route path="/quote" element={<QuotePage />} />
                    <Route path="/quote/:productId" element={<QuotePage />} />
                    <Route path="/guidance" element={<GuidancePage />} />
                    <Route path="/used-machines" element={<UsedMachinesPage />} />
                    <Route path="/air-compressors" element={<AirCompressorPage />} />
                    <Route path="/accessories" element={<AccessoriesPage />} />
                    <Route path="/dry-ice-pelletizer" element={<DryIcePelletizerPage />} />
                    <Route path="/return-policy" element={<ReturnPolicyPage />} />
                    <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/thank-you" element={<ThankYouPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="/rent" element={<RentPage />} />
                    <Route path="/rent/:machineId" element={<RentalDetailPage />} />
                    <Route path="/rental/confirmation/:bookingId" element={<RentalConfirmationPage />} />
                    <Route path="/cart" element={<CartPage />} />
                    <Route path="/checkout" element={<CheckoutPage />} />
                    <Route path="/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
                    <Route path="/blog" element={<BlogPage />} />
                    <Route path="/blog/:slug" element={<BlogPostPage />} />
                    <Route path="/login" element={<CustomerLoginPage />} />
                    <Route path="/register" element={<CustomerRegisterPage />} />
                    <Route path="/account" element={<CustomerDashboardPage />} />
                </Route>
                
                {/* Admin Routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route element={<AdminLayout />}>
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/products" element={<AdminProducts />} />
                    <Route path="/admin/categories" element={<AdminCategories />} />
                    <Route path="/admin/quotes" element={<AdminQuotes />} />
                    <Route path="/admin/comparisons" element={<AdminComparisons />} />
                    <Route path="/admin/settings" element={<AdminSettings />} />
                    <Route path="/admin/orders" element={<AdminOrders />} />
                    <Route path="/admin/rentals" element={<AdminRentals />} />
                    <Route path="/admin/blog" element={<AdminBlog />} />
                </Route>
            </Routes>
            <Toaster position="top-right" />
        </BrowserRouter>
        </CartProvider>
        </AuthProvider>
    );
}

export default App;
